"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workPermitTypeInsideCanadaList = exports.workPermitTypeList = void 0;
exports.workPermitTypeList = [
    {
        value: "OWP",
        label: "Open Work Permit",
    },
    {
        value: "SAWP",
        label: "Seasonal Agricultural Workers Program",
    },
    {
        value: "ELMO",
        label: "Exemption from Labour Market Impact Assessment",
    },
    {
        value: "LMOS",
        label: "Labour Market Impact Assessment Stream",
    },
    {
        value: "SBC",
        label: "Start-up Business Class",
    },
    {
        value: "Other",
        label: "Other",
    },
];
exports.workPermitTypeInsideCanadaList = [
    {
        value: "COWP",
        label: "Co-op Work Permit",
    },
    {
        value: "ELMO",
        label: "Exemption from Labour Market Impact Assessment",
    },
    {
        value: "LMOS",
        label: "Labour Market Impact Assessment Stream",
    },
    {
        value: "LCP",
        label: "Live-in Caregiver Program",
    },
    {
        value: "OWP",
        label: "Open Work Permit",
    },
    {
        value: "VWOWP",
        label: "Open Work Permit for Vulnerable Workers",
    },
    {
        value: "PGWP",
        label: "Post Graduation Work Permit",
    },
    {
        value: "SBC",
        label: "Start-up Business Class",
    },
    {
        value: "Other",
        label: "Other",
    },
];
